<asw-common-error-pres
  [errorInfo]="errorInfo"
  [displayErrorKey]="displayErrorKey$ | async"
  [fixedErrorMsgKey]="fixedErrorMsgKey"
  [buttonLabelMsgKey]="buttonLabelMsgKey"
  [showBtn]="showBtn"
  [showCloseBtn]="showCloseBtn"
  (confirm$)="confirmNavigate()"
  (close$)="popupClose()"
></asw-common-error-pres>
